module.exports = __webpack_public_path__ + "static/media/warning_yellow.fed667df.png";